<template>
  <div class="min-height">
    <TableLoading v-if="products.page === 0"/>
    <div v-else>
      <form @submit.prevent="shipmentAction">
        <div class="row">
          <div class="col-sm-6">
            <div class="mb-3">
              <label>Product</label>
              <multiselect v-model="shipment.productId" :options="products.objects" :class="{'is-invalid': v$.shipment.productId.$error}"
                           placeholder="Select one" label="productName" track-by="productName" :searchable="true" :internal-search="false" @search-change="asyncFindProduct">
                <span slot="noResult">No product found. Change search query.</span>
              </multiselect>
              <p
                  v-for="error of v$.shipment.productId.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label>Warehouse</label>
              <multiselect v-model="shipment.warehouseId" :options="warehouses.objects" :class="{
                        'is-invalid': v$.shipment.warehouseId.$error,
                  }" placeholder="Select one" label="name" track-by="name"></multiselect>

              <p
                  v-for="error of v$.shipment.warehouseId.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label>Quantity</label>
              <input
                  v-model="shipment.quantity"
                  name="name"
                  type="number"
                  class="form-control"
                  :class="{
            'is-invalid': v$.shipment.quantity.$error,
          }"
              />
              <p
                  v-for="error of v$.shipment.quantity.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label>B/L</label>
              <input
                  v-model="shipment.orderId"
                  name="name"
                  type="text"
                  class="form-control"
                  :class="{
            'is-invalid': v$.shipment.orderId.$error,
          }"
              />
              <p
                  v-for="error of v$.shipment.orderId.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label>Date Ordered</label>
              <date-picker v-model="shipment.dateOrdered" format="YYYY-MM-DD" valueType="format" :class="{
                        'is-invalid':v$.shipment.dateOrdered.$error,
                  }"></date-picker>
              <p
                  v-for="error of v$.shipment.dateOrdered.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label>Expiry Date</label>
              <date-picker v-model="shipment.expiryDate" format="YYYY-MM-DD" valueType="format" :class="{
                          'is-invalid': v$.shipment.expiryDate.$error,
                    }"></date-picker>
              <p
                  v-for="error of v$.shipment.expiryDate.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label>Purchase Price</label>
              <input
                  v-model="shipment.orderPrice"
                  name="name"
                  type="text"
                  class="form-control"
                  :class="{
            'is-invalid': v$.shipment.orderPrice.$error,
          }"
              />
              <p
                  v-for="error of v$.shipment.orderPrice.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
        </div>
        <div v-for="(error, index) in stockErrors" :key="index" style="color: #D13704;">
          {{error.message}}
        </div>
        <div class="mt-3 col-12">
          <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="stockLoading">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Loading
          </b-button>
          <b-button variant="primary" size="lg" class="py-3 h3 w-100 text-white" type="submit" v-else>
            {{ button_text }}
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Multiselect from 'vue-multiselect'
import {ALL_PRODUCTS_SIMPLE, ALL_WAREHOUSES} from "@/gql/stock";
import {mapGetters} from "vuex";
import TableLoading from "@/components/TableLoading";
export default {
  name: "shipment-form",
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    TableLoading,
    Multiselect
  },
  data(){
    return {
      shipment: this.selected_shipment,
      productSearchKeyword: "",
      warehouses: {
        objects: []
      },
      products: {
        page: 0,
        objects: []
      }
    }
  },
  apollo: {
    warehouses: {
      query: ALL_WAREHOUSES,
      variables(){
        return {
          page: 1,
          perPage:30,
          isActive: true,
        }
      }
    },
    products: {
      query: ALL_PRODUCTS_SIMPLE,
      variables(){
        return {
          page: 1,
          perPage:30,
          searchKeyword: this.productSearchKeyword
        }
      }
    }
  },
  computed: {
    ... mapGetters({
      stockLoading: 'stock/stockLoading',
      stockErrors: 'stock/stockErrors'
    }),
  },
  props: {
    button_text: {type: String},
    selected_shipment: {
      type: Object,
      default (){
        return {
          productId: "",
          warehouseId: "",
          orderId: "",
          dateOrdered: "",
          expiryDate: "",
          quantity: "",
          orderPrice: ""
        }
      }
    },
  },
  validations () {
    return {
      shipment:{
        productId: {required},
        warehouseId: {required},
        orderId: {required},
        dateOrdered: {required},
        expiryDate: {required},
        quantity: {required},
        orderPrice: {required}
      }
    }
  },
  methods: {
    async shipmentAction() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        orderId: this.shipment.orderId,
        productId: this.shipment.productId.publicId,
        warehouseId: this.shipment.warehouseId.publicId,
        quantity: parseInt(this.shipment.quantity),
        orderPrice: parseInt(this.shipment.orderPrice),
        dateOrdered: this.shipment.dateOrdered,
        expiryDate: this.shipment.expiryDate
      }

      this.$emit('shipmentAction', data)
      this.v$.$touch();
    },
    asyncFindProduct (query) {
      this.productSearchKeyword = query
    }
  }
}
</script>

<style scoped>

</style>
